import { createHashHistory, createBrowserHistory } from "history";
export default createHashHistory();